import { Component, EventEmitter, Input, NgZone, OnChanges, OnInit, Output, SimpleChange, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CurrentActivatedPlan } from 'src/app/models/activated-subscription.model';
import { UserDetails } from 'src/app/models/user-details.model';
import { CampaignService } from 'src/app/services/campaign/campaign.service';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { FormsService } from 'src/app/services/Forms/forms.service';
import { WindowRefService } from 'src/app/services/razor-pay-gateway/window-ref.service';
import { SubscriptionService } from 'src/app/services/subscription/subscription.service';
import { Ga4trackingService } from 'src/app/services/ga4Tracking/ga4tracking.service';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'ipm-campaign-funding',
  templateUrl: './campaign-funding.component.html',
  styleUrls: ['./campaign-funding.component.scss']
})
export class CampaignFundingComponent implements OnInit, OnChanges {
  topUpForm: FormGroup = new FormGroup({});
  selectedPreset = 2500;
  readonly presets = [1000, 2500, 5000, 10000];
  numberOfDays: number = 0;
  calCualtedMinFunding: number = 0;
  amountToFill: number = 0;
  @Input() walletDetails: any= "";
  producerwalletBalance: number = 0;
  @Input() currentRequiredAmount: number = 0;
  currentUserDetails: UserDetails;
  @Output() onActionTrigger: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('paymentSuccessPopup', { static: false }) paymentSuccessPopup: TemplateRef<any>;
  @ViewChild('billingAddressesTemplate') billingAddressesTemplate!: TemplateRef<any>;
  currentTier: any = "tier0";
  constructor(public commonService: CommonService,
  public formService: FormsService,
  private compaignService: CampaignService,
  private ngZone: NgZone,
  private winRef: WindowRefService,
  private subscriptionService: SubscriptionService,
  public ga4Tracking: Ga4trackingService,
  public browserStorageService: BrowserStorageService) { }
  

  ngOnInit(): void {
    this.getActivatedSubscription();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['walletDetails']) {
      this.producerwalletBalance = this.walletDetails.currentWalletBalance;
      // convert negative required amount to positive
      this.currentRequiredAmount = Math.abs(this.walletDetails.currentRequiredAmount || 0);
      this.currentUserDetails = this.walletDetails.currentUserDetails;
      // determine min amount
      const minAmount = this.currentRequiredAmount > 0 ? this.currentRequiredAmount : 500;
      this.selectedPreset = minAmount;
      this.topUpForm = new FormGroup({
        topUpAmount: this.formService.getFormControl('number', this.selectedPreset, minAmount, 100000)
      });

      console.log('walletDetails changed:', this.topUpForm);
    }
  }

    getActivatedSubscription() {
      this.subscriptionService.activeSubscription.subscribe( (activeSubs: CurrentActivatedPlan) => {
        if (activeSubs &&  Object.keys(activeSubs).length > 0) {
          if (activeSubs.subscriptionTiers.length > 0) {
             if (activeSubs.subscriptionTiers.includes('tier2')) {
                this.currentTier = "tier2";
             } else if (activeSubs.subscriptionTiers.includes('tier1')) {
                this.currentTier = "tier1";
             }
          }
        }
      }, error => {
        this.commonService.showToastError(error);
      })
    }

  onPresetSelect(value: number): void {
    if (this.currentRequiredAmount > 0 && value > this.currentRequiredAmount) {
      this.selectedPreset = value;
      this.updateValueOnForm();
      return;
    }
    this.selectedPreset = value;
    this.updateValueOnForm();
  }

  updateValueOnForm() {
   this.topUpForm.controls['topUpAmount'].setValue(this.selectedPreset);
  }

  onAmountInput(value: string): void {

  }

  closePopup() {
    this.commonService.closePopUp();
  }

  orderFundCreated() {
    this.openAddressModelInternal();
  }

  openAddressModelInternal() {
    let className = this.commonService.getClassName('ipm-billing-address-popup-model');
    this.commonService.openModel(this.billingAddressesTemplate, { }, className, true);
    if (this.commonService.isMobileDisableClick) {
      this.commonService.bottomRef.afterDismissed().subscribe((response: any) => {
        this.onCloseModelPopup(response);
      });
    } else {
      this.commonService.modelRef.afterClosed().subscribe((response: any) => {
        this.onCloseModelPopup(response);
      });
    }
  }

  onCloseModelPopup(response: any) {
    if (response && response.actionType === 'Checkout') {
      const formValue = this.topUpForm.value;
      const amountToAdd = formValue.topUpAmount;
      let payload: any = {
        amount: amountToAdd, // Convert to paise
        billing_address_id: response.selectedAddress._id
      };
      this.compaignService.addFundsToWallet(payload).subscribe((res: any) => {
        this.openPaymentGateway(res.data);
      }, (error) => {
        this.closePopup();
        this.commonService.showToastError(error);
      });
    }
  }

   /**
     * In this function open Payment gateway
     * @param orderData 
     */
    openPaymentGateway(orderData: any) {
      const options: any = {
        key: environment.rozarPayDevKey,
        currency: 'INR',
        modal: {
          escape: false,
        },  
        order_id: orderData?.orderId,
        prefill: {
          "name": this.currentUserDetails?.name,
          "email": this.currentUserDetails?.email
        }
      };
   
      options.handler = ((response: any, error:any) => {
        let attributes: any = {
          category: 'Beats',
          label: 'Add Funds',
          action: 'click',
          transaction_id: response?.razorpay_payment_id || '',
          order_id: response?.razorpay_order_id || '',
          value: orderData?.amount || this.selectedPreset,
          currency: 'INR',
          userRole: this.browserStorageService?.getCurrentRoles() || 'guest',
          userId: this.browserStorageService?.getUserId() || 'guest'
        };
        this.ga4Tracking.sendEvent('campaign_fund_added', attributes);
        this.ga4Tracking.sendEvent('Purchase', attributes);
        this.ngZone.run(() => {
          this.paymentSuccess();
        });
      });
      options.modal.ondismiss = (() => {
        this.ngZone.run(() => {
          this.commonService.showToastErrorMessage('Transaction cancelled');
        });
      });
  
      const rzp = new this.winRef.nativeWindow.Razorpay(options);
      rzp.open();
      rzp.on('payment.failed', (response: any) => {
        this.ngZone.run(() => {
          this.commonService.showToastErrorMessage('Payment Failed');
        });
      });
    }

    paymentSuccess(type: string = "coupon", currentPlan: any = "") {
      this.closePopup();
      let messageData: string = "<p> Fund Added Successfully</p><p>Your campaign fund has been added successfully. You can now launch your campaign.</p>";
      let sendData = {
        popType: type,
        buttonText: "Close",
        message: messageData
      }
      let classNotifyName =  this.commonService.getClassName('ipm-payment-success-popup-model');
      this.commonService.openModel(this.paymentSuccessPopup,sendData,classNotifyName,false);
      this.onActionTrigger.emit("walletRefresh");
    }

}
